<template>
  <div class="products-area ptb-100">
    <div class="container mw-1356">
      <div class="section-title mw-860">
        <span class="top-title">المتجر</span>
        <h2>اختر اشتراكك المناسب</h2>
      </div>

      <div class="row">
        <div class="col-lg-9 order-2 order-lg-1">
          <div class="row justify-content-center">
            <div
              v-for="product in products"
              :key="product.id"
              class="col-xl-4 col-md-6"
            >
              <div class="products-single-item transition-y">
                <div class="product-img position-relative z-1">
                  <RouterLink :to="`/product-details/${product.id}`" class="d-block">
                    <img :src="product.image" :alt="product.name" />
                  </RouterLink>
                  <a
                    class="btn"
                    @click="addToCart(product)"
                    :disabled="isInCart(product.id)"
                  >
                    <span class="border-style">
                      {{ isInCart(product.id) ? "في السلة" : "إضافة إلى السلة" }}
                    </span>
                  </a>
                </div>

                <div class="product-content">
                  <ul class="ps-0 list-unstyled d-flex review">
                    <li v-for="star in 5" :key="star">
                      <i class="ri-star-s-fill"></i>
                    </li>
                  </ul>
                  <h3>
                    <RouterLink :to="`/product-details/${product.id}`">
                      {{ product.name }}
                    </RouterLink>
                  </h3>
                  <h4>
                    <del v-if="product.oldPrice">{{ product.oldPrice }} €</del>
                    {{ product.price }} €
                  </h4>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="pagination-area text-center mt-0">
                <span
                  class="next page-numbers"
                  @click="goToPage(currentPage - 1)"
                  :disabled="currentPage === 1"
                >
                  <i class="ri-arrow-left-s-line"></i>
                </span>

                <span
                  v-for="page in totalPages"
                  :key="page"
                  class="page-numbers"
                  :class="{ current: page === currentPage }"
                  @click="goToPage(page)"
                >
                  {{ page }}
                </span>

                <span
                  class="next page-numbers"
                  @click="goToPage(currentPage + 1)"
                  :disabled="currentPage === totalPages"
                >
                  <i class="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0">
          <SidebarWidget />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { useHead } from "@unhead/vue";
import { useCartStore } from "@/store/index";
import SidebarWidget from "./SidebarWidget.vue";

export default defineComponent({
  name: "ProductsList",
  components: {
    SidebarWidget,
  },
  setup() {
    useHead({
      title: "متجر اشتراكات IPTV | باقات IPTV وأجهزة جاهزة",
      meta: [
        {
          name: "description",
          content:
            "اختر من بين أفضل باقات اشتراك IPTV، اشتراكات شهرية وسنوية، باقات عائلية، أجهزة Fire TV Stick وAndroid TV Box جاهزة ومبرمجة بجودة HD و4K.",
        },
        {
          name: "keywords",
          content:
            "متجر IPTV, اشتراكات IPTV, باقات IPTV, IPTV 4K, Fire TV Stick IPTV, Android TV Box, قنوات عربية, VOD, اشتراك IPTV",
        },
        {
          property: "og:title",
          content: "متجر اشتراكات IPTV | باقات وأجهزة جاهزة",
        },
        {
          property: "og:description",
          content:
            "استعرض باقات IPTV والأجهزة الجاهزة واختر الاشتراك المناسب لك بجودة عالية وثبات ممتاز.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/products",
        },
      ],
    });

    const cartStore = useCartStore();

    const products = ref([
      {
        id: 1,
        image: require("@/assets/images/product-1.jpg"),
        name: "اشتراك IPTV الماسي - 12 شهر (شاشتين في نفس الوقت)",
        price: 60.0,
        oldPrice: 90.0,
      },
      {
        id: 2,
        image: require("@/assets/images/product-2.jpg"),
        name: "اشتراك IPTV الماسي - 6 أشهر (ثبات مطلق للمباريات)",
        price: 35.0,
      },
      {
        id: 3,
        image: require("@/assets/images/product-3.jpg"),
        name: "اشتراك IPTV الماسي - 3 أشهر (جميع القنوات والـ VOD)",
        price: 25.0,
      },
      {
        id: 4,
        image: require("@/assets/images/product-4.jpg"),
        name: "جهاز Fire TV Stick 4K مجهز ومبرمج باشتراك سنة كاملة",
        price: 95.0,
      },
      {
        id: 5,
        image: require("@/assets/images/product-5.jpg"),
        name: "باقة العائلة المتكاملة - اشتراك IPTV لمدة 12 شهر (3 أجهزة)",
        price: 85.0,
      },
      {
        id: 6,
        image: require("@/assets/images/product-6.jpg"),
        name: "اشتراك IPTV VIP - لمدة 12 شهر بجودة 4K حقيقية",
        price: 70.0,
      },
      {
        id: 7,
        image: require("@/assets/images/product-7.jpg"),
        name: "جهاز Android TV Box مبرمج بالكامل مع اشتراك 6 أشهر",
        price: 75.0,
      },
      {
        id: 8,
        image: require("@/assets/images/product-8.jpg"),
        name: "باقة تجريبية خاصة - اشتراك IPTV لمدة شهر كامل",
        price: 10.0,
        oldPrice: 15.0,
      },
      {
        id: 9,
        image: require("@/assets/images/product-9.jpg"),
        name: "الاشتراك الملكي المستقر - سنتين كاملتين (24 شهر)",
        price: 110.0,
      },
    ]);

    interface Product {
      id: number;
      image: string;
      name: string;
      price: number;
      oldPrice?: number;
      quantity?: number;
    }

    const addToCart = (product: Product) => {
      cartStore.addToCart(product);
    };

    const isInCart = (productId: number) =>
      cartStore.cart.some((item) => item.id === productId);

    const currentPage = ref(1);
    const productsPerPage = 6;

    const totalPages = computed(() =>
      Math.ceil(products.value.length / productsPerPage)
    );

    const paginatedProducts = computed(() => {
      const start = (currentPage.value - 1) * productsPerPage;
      return products.value.slice(start, start + productsPerPage);
    });

    const goToPage = (page: number) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

    return {
      products: paginatedProducts,
      addToCart,
      isInCart,
      currentPage,
      totalPages,
      goToPage,
    };
  },
});
</script>